import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _FilterBigLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M10 8h10M4 16h10" }),
            React.createElement("circle", { cx: 7, cy: 8, r: 3, stroke: "currentColor", strokeLinecap: "round", transform: "rotate(90 7 8)" }),
            React.createElement("circle", { cx: 17, cy: 16, r: 3, stroke: "currentColor", strokeLinecap: "round", transform: "rotate(90 17 16)" })));
}
const FilterBigLight = forwardRef(_FilterBigLight);
export { FilterBigLight };
